import { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Home from '@/pages/Home';
import History from '@/pages/History';
import Analysis from '@/pages/Analysis';
import '@/App.css';

export default function App() {
  const [darkMode, setDarkMode] = useState(false);

  return (
    <div className={darkMode ? 'dark' : ''}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home darkMode={darkMode} setDarkMode={setDarkMode} />} />
          <Route path="/history" element={<History darkMode={darkMode} setDarkMode={setDarkMode} />} />
          <Route path="/analysis/:id" element={<Analysis darkMode={darkMode} setDarkMode={setDarkMode} />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}
